module.exports = __webpack_public_path__ + "img/tel1.6e49dc0e.png";